






























































































































































































































































import { Component } from "vue-property-decorator";
import { RoomInterface } from "@/resources/interfaces/roomInterfaces";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { MAX_SIZE_FILE } from "@/resources/constants/system";
import { ROOM_TYPE } from "@/resources/constants/space";
import SelectRoomComponent from "@/app/components/selectRoom/selectRoom.component.vue";
import AutoPlayValidador from "@/resources/mixins/autoPlayValidator";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "update-rooms-component",
  components: { SelectRoomComponent },
})
export default class UpdateRoomsComponent extends mixins(
  NotificationEvent,
  AutoPlayValidador,
  Plans
) {
  PLAN = PLAN;
  SPEED_NETWORKING = ROOM_TYPE.SPEED_NETWORKING;
  MEETING = ROOM_TYPE.MEETING;
  ROOM_TYPE = ROOM_TYPE;
  backgroundImage = null;
  backgroundImageUrl = "";
  loading = false;
  name = "";
  pin = "";
  url = "";
  videoUrl = "";
  isVideoUrlLockedByAdmin = false;
  description = "";
  isBooth = false;
  openUrlExternally = false;
  selectorRoom = 0;
  roomSelectedId = 0;
  autoplay = false;
  roomSelected: RoomInterface | null = null;
  activeNotepad = false;
  notepadText = null;
  constructor() {
    super();
  }
  mounted() {
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    const rooms = space.scenario.rooms.sort(
      (a, b) => a.graphicClientRoomId - b.graphicClientRoomId
    );
    this.roomSelected = rooms.filter(
      (a) => a.graphicClientRoomId === this.roomSelectedId
    )[0];
    this.name = this.roomSelected.name;
    this.url = this.roomSelected.wonderPoint.url;
    this.videoUrl = this.roomSelected.videoUrl;
    this.description = this.roomSelected.description;
    this.isVideoUrlLockedByAdmin = this.roomSelected.isVideoUrlLockedByAdmin;
    this.isBooth = this.roomSelected.isBooth;
    this.openUrlExternally = this.roomSelected.wonderPoint.openUrlExternally;
    this.activeNotepad = this.roomSelected.hasNotes;
    this.notepadText = this.roomSelected.notes;
    let data = {
      position: 0,
      room: {
        id: this.roomSelected.id,
      },
    };
    this.selectRoom(data);
  }

  get labelName(): string {
    return this.roomSelected.name
      ? this.roomSelected.name
      : `room ${this.roomSelected.graphicClientRoomId}`;
  }

  get isLocked(): boolean {
    return this.roomSelected.isLockedByAdmin
      ? this.roomSelected.isLockedByAdmin
      : false;
  }

  set isLocked(e) {
    this.roomSelected.isLockedByAdmin = e;
  }

  get validUrl(): boolean {
    if (!this.url) return true;
    const regex = RegExp(
      /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
    );
    return regex.test(this.url);
  }
  get validVideoUrl(): boolean {
    if (!this.videoUrl) return true;
    const regex = RegExp(
      /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
    );
    return regex.test(this.videoUrl);
  }
  get isMultiWebinar(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return space.superSpace.isMultiWebinarActivated;
  }
  selectFile(ref: any): void {
    if (this.$refs[ref]["files"][0].size >= MAX_SIZE_FILE) {
      this.onError(
        this.$i18n.t("notifications.titles.error"),
        this.$i18n.t("notifications.errorMessages.maxFileSize")
      );
      return;
    }
    const allImages = ["image/png", "image/jpg", "image/jpeg"];

    if (allImages.indexOf(this.$refs[ref]["files"][0].type) < 0) {
      this.onError(
        this.$i18n.t("notifications.titles.error"),
        this.$i18n.t("notifications.errorMessages.fileType")
      );
      return;
    }
    if (this.$refs[ref]["files"].length > 0) {
      this.backgroundImage = this.$refs[ref]["files"];
      const fr = new FileReader();
      setTimeout(() => {
        const img = document.getElementById(ref);
        fr.onload = (event) => {
          if (event) {
            if (img instanceof HTMLImageElement)
              img.src = event ? event?.target.result.toString() : "";
          }
        };
        fr.readAsDataURL(this.backgroundImage[0]);
      }, 200);
    }
  }
  onSave(): void {
    if (this.url && this.url.length != 0 && !this.checkUrl(this.url)) {
      return;
    }
    if (
      this.videoUrl &&
      this.videoUrl.length != 0 &&
      !this.checkUrl(this.videoUrl)
    ) {
      return;
    }
    this.loading = true;
    const scene = this.$store.getters["SpaceStore/getSpace"].scenario;
    this.$store.dispatch("SpaceStore/updateRoomAction", {
      roomId: this.roomSelected.id,
      data: {
        name: this.name,
        pin: this.pin === "" ? null : parseInt(this.pin),
        isLockedByAdmin: this.isLocked,
        wonderPoint: {
          id: this.roomSelected.wonderPoint.id,
          url: this.url,
          openUrlExternally: this.openUrlExternally,
        },
        videoUrl: this.videoUrl,
        isVideoUrlLockedByAdmin: this.isVideoUrlLockedByAdmin,
        description: this.description,
        hasNotes: this.activeNotepad,
        notes: this.notepadText,
      },
      callback: () => {
        this.selectorRoom += 1;
        if (this.backgroundImage) {
          const formData = new FormData();
          formData.append("file", this.backgroundImage[0] || "");
          formData.append("room", this.roomSelected.id.toString());
          this.$store.dispatch("SpaceStore/uploadRoomFileAction", {
            data: formData,
            callback: (data) => {
              this.loading = false;
              const img = document.getElementById("backgroundImage");
              if (img instanceof HTMLImageElement) {
                img.src = data.url;
                this.backgroundImage = null;
                this.backgroundImageUrl = data.url;
                this.roomSelected.image = data;
              }
              this.onSuccess(
                i18n.t("notifications.titles.success"),
                i18n.t("notifications.descriptions.roomUpdate")
              );
            },
            callbackErr: (error) => {
              this.loading = false;
            },
          });
        } else {
          this.loading = false;
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.roomUpdate")
          );
        }
      },
      callbackError: (error) => {
        this.loading = false;
        this.onError("", i18n.t("notifications.genericError.updateRoom"));
      },
    });
  }
  checkUrl(url: string): boolean {
    const regex = RegExp(
      /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
    );
    return regex.test(url);
  }
  selectRoom(e) {
    this.$store.dispatch("SpaceStore/getRoomAction", {
      roomId: e.room.id,
      callback: (data) => {
        this.name = data.name;
        this.url = data.wonderPoint.url;
        this.description = data.description;
        this.videoUrl = data.videoUrl;
        this.isVideoUrlLockedByAdmin = data.isVideoUrlLockedByAdmin;
        this.isBooth = data.isBooth;
        this.autoplay = this.getAutoplay(this.autoplay, this.videoUrl);
        this.openUrlExternally = data.wonderPoint.openUrlExternally;
        this.activeNotepad = data.hasNotes;
        this.notepadText = data.notes;
        if (e.room.id !== this.roomSelected.id) {
          const img = document.getElementById("backgroundImage");
          if (img instanceof HTMLImageElement) {
            img.src = "";
          }
          this.backgroundImage = null;
          this.backgroundImageUrl = "";
          if (this.$refs.backgroundImage) {
            this.$refs.backgroundImage["type"] = "text";
            this.$refs.backgroundImage["type"] = "file";
          }
        }
        this.roomSelected = data;
        this.pin = "";
      },
      callbackError: (error) => {
        //do nothing
      },
    });
    this.roomSelectedId = e.position;
  }
  isNumber(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  }
  async removeImageRoom() {
    if (!this.roomSelected.image) return;
    await this.$store.dispatch("SpaceStore/removeImageRoomAction", {
      imageId: this.roomSelected.image.id,
      callback: (response) => {
        this.backgroundImage = null;
        this.backgroundImageUrl = "";
        this.roomSelected.image = "";
      },
      callbackError: (error) => {
        this.onError("", i18n.t("notifications.genericError.updateImage"));
      },
    });
  }
}
